// Every indexable route on the site. Used by the router-adjacent components,
// the prerender script, and the generated sitemap so they stay in sync.
// CommonJS so the Node build scripts can require it too.

const services = require("../components/Services/services.json");
const locations = require("./locations.json");

const slugify = (text) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const staticRoutes = ["/", "/services", "/about", "/faq", "/contact"];

const serviceRoutes = services.map((s) => `/services/${slugify(s.title)}`);

const locationRoutes = locations.map((l) => `/${l.slug}`);

const indexableRoutes = [...staticRoutes, ...locationRoutes, ...serviceRoutes];

// Pre-rendered but kept out of the sitemap (pages that set noindex).
const prerenderRoutes = [...indexableRoutes, "/gallery"];

module.exports = {
  slugify,
  services,
  locations,
  indexableRoutes,
  prerenderRoutes,
};
